import { authHeader } from '../../_helpers';
import axios from 'axios';

export const AnalyzeService = {
    getAnalyzeData,
    orientationAPI_service,
}

axios.defaults.headers.common = authHeader();
let token = localStorage.getItem('access_token')


// function makeRequestCreator() {
//     var call;
//     return function(url) {
//         if (call) {
//             call.cancel();
//         }
//         call = axios.CancelToken.source();
//         return axios.get(url, { cancelToken: call.token }).then((response) => {
//             console.log('requestrequest',response)
//         }).catch(function(thrown) {
//             if (axios.isCancel(thrown)) {
//                 console.log('First request canceled', thrown.message);
//             } else {
//                 // handle error
//             }
//         });
//     }
// }
// var get = makeRequestCreator();
// get('https://jsonplaceholder.typicode.com/posts/1');
// get('https://jsonplaceholder.typicode.com/posts/1');
// get('https://jsonplaceholder.typicode.com/posts/1');
// get('https://jsonplaceholder.typicode.com/posts/1');
// get('https://jsonplaceholder.typicode.com/posts/1');
// function noel () {
//     get('https://jsonplaceholder.typicode.com/posts/1');
//     get('https://jsonplaceholder.typicode.com/posts/1');
//     get('https://jsonplaceholder.typicode.com/posts/1');
//     get('https://jsonplaceholder¯.typicode.com/posts/1');
// };


function getAnalyzeData(data) {
    return axios.post(`/analytics/analytics_organisation/team/analyse/?access_token=${token}`,data)
        .then(response => {
            return response;
        });
}

function orientationAPI_service() {
    return axios.get(`/analytics/list/orientations/attrbutes?access_token=${token}`)
        .then(response => {
            return response;
        });
}


// WEBPACK FOOTER //
// ./src/_services/Analyze/analyze.service.js